import { render, staticRenderFns } from "./CooperationCard.vue?vue&type=template&id=1f3662f4&scoped=true&"
import script from "./CooperationCard.vue?vue&type=script&lang=js&"
export * from "./CooperationCard.vue?vue&type=script&lang=js&"
import style0 from "./CooperationCard.vue?vue&type=style&index=0&id=1f3662f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3662f4",
  null
  
)

export default component.exports